
/**
 * When I wrote this code,Only God and I understood what I was doing.
 * Now,God only knows  !!!
 */
import {Component, Emit, Prop, Watch, Vue} from "vue-property-decorator";
import schedule from "./schedule.vue";

@Component({
    components: {
        schedule
    },
})
export default class FusionClass extends Vue {

}
